import AntIcon from "@/components/icons/AntIcon";
import { Button, Card } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Permission } from "../../../../common/security/enums";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";
import { CommissionsBatchFilterPageRequest } from "../types";
import { CreateCommissionsBatchForm } from "./forms/CreateCommissionsBatchForm";
import { CommissionsBatchFilterForm } from "./forms/filter/CommissionsBatchFilterForm";

interface Props {
  searchParams: CommissionsBatchFilterPageRequest;
}

export const CommissionsBatchFilter = ({ searchParams }: Props) => {
  const { t } = useTranslation();

  const [createBatchFormOpen, setCreateBatchFormOpen] = useState(false);

  return (
    <Card
      className="card-box"
      title={<h2>{t("commissions.batch.titles.batchesList")}</h2>}
      extra={
        <ComponentWithPermission permissions={[Permission.COMMISSIONS_MANAGE]}>
          <Button type="primary" icon={<AntIcon type="plus" />} onClick={() => setCreateBatchFormOpen(true)}>
            {t("commissions.batch.actions.addBatch")}
          </Button>
        </ComponentWithPermission>
      }
    >
      <CommissionsBatchFilterForm searchParams={searchParams} />

      <CreateCommissionsBatchForm open={createBatchFormOpen} onFormCancel={() => setCreateBatchFormOpen(false)} />
    </Card>
  );
};
